import axios from 'axios'

export const TransferRegionApi = {
    async Table(data){
        const response = await axios.post('/api/transferregion/table',data)
        return response
    },
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/transferregion/update' : '/api/transferregion/create' , data)
        return response
    },
    async Delete(data){
        const response = await axios.post(`/api/transferregion/delete/${data}`)
        return response
    },
    async List(){
        const response = await axios.get(`/api/transferregion/list`)
        return response
    },
    async ListOwnFirm(){
        const response = await axios.get(`/api/transferregion/ownfirm/list`)
        return response
    }
}